import { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import Problem from '../components/Problem';
import Solution from '../components/Solution';
import HowItWorks from '../components/HowItWorks';
import DareExamples from '../components/DareExamples';
import WhyDareUp from '../components/WhyDareUp';
import Safety from '../components/Safety';
import Waitlist from '../components/Waitlist';
import SocialProof from '../components/SocialProof';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import { getWaitlistStats } from '../api/waitlist';

export default function HomePage() {
    const [signupCount, setSignupCount] = useState<number>(0);

    useEffect(() => {
        // Fetch current waitlist stats
        getWaitlistStats()
            .then((stats) => setSignupCount(stats.count))
            .catch(() => setSignupCount(0));
    }, []);

    return (
        <div className="min-h-screen bg-white">
            <Hero signupCount={signupCount} />
            <Problem />
            <Solution />
            <HowItWorks />
            <DareExamples />
            <WhyDareUp />
            <Safety />
            <Waitlist onSignupSuccess={() => setSignupCount((prev) => prev + 1)} />
            <SocialProof signupCount={signupCount} />
            <FAQ />
            <Footer />
        </div>
    );
}
